<script setup lang="ts"></script>

<template>
  <RouterView v-slot="{ Component, route }">
    <component
      :is="Component"
      :key="route.path"
    />
  </RouterView>
  <div class="copyright">Copyright © 2026 - EventApp Software sp. z o.o.</div>
</template>

<style scoped>
.copyright {
  position: fixed;
  bottom: 10px;
  right: 10px;
  font-size: 10px;
  color: #666;
  z-index: 1000;
}
</style>
